




























































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";

export interface Data {
  condition: any
  sheets: any[]
  school_id: number
  errors: any[]
  resultDetailUrl: string
  is_exists_not_download_file: boolean
  totalCount: number
  isShow: boolean
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: {
        nendo: "",
        month: "",
        curriculum_id: "",
        grade: "",
        status: "",
        page: 1,
        row_count: 20,
      },
      sheets: [],
      school_id: context.root.$store.state.currentUser.school_id,
      errors: [],
      resultDetailUrl: "",
      is_exists_not_download_file: false,
      totalCount: 0,
      isShow: false,
    });

    const clearCondition = () => {
      state.condition = {
        nendo: "",
        month: "",
        curriculum_id: "",
        grade: "",
        status: "",
        page: 1,
        row_count: 20,
      };
    }

    const searchClick = async () => {
      state.condition.page = 1;
      await search();
      if(state.sheets.length == 0){
        alert("検索条件に該当する試験はありません。");
      }
    }

    /******************************
     * ページング
     ******************************/

    const changePage = async (page: number) => {
      state.condition.page = page;
      await search();
      if(state.sheets.length == 0){
        alert("検索条件に該当する試験はありません。");
      }
    };
    
    const search = async () => {

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      await http.get(`/api/student/sheet_list?student_no_character=${context.root.$store.state.student_no_character}&${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        state.sheets = response.data.sheets;
        state.is_exists_not_download_file = response.data.is_exists_not_download_file;
        state.totalCount = state.sheets.length > 0 ? state.sheets[0].full_count : 0;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }


    const convertExecDate = (execDate: any) => {
      return execDate ? moment(execDate).format('Y年M月D日') : "-";
    }

    const convertTestStartDateTime = (testStartDate: any) => {
      return testStartDate ? moment(testStartDate).format('Y/M/D HH:mm') : "-";      
    }

    const convertTestStartDateTimeMobile = (sheet: any, isWrap: boolean) => {
      var testStartDateTimeAt = sheet.test_start_datetime_at ? moment(sheet.test_start_datetime_at).format('Y/M/D HH:mm') : "";
      
      var testStartDateTimeTo: any = new Date(sheet.test_start_datetime_at);
      testStartDateTimeTo.setMinutes(testStartDateTimeTo.getMinutes() + sheet.grace_time);
      testStartDateTimeTo = moment(testStartDateTimeTo).format('Y/M/D HH:mm');
      return `${testStartDateTimeAt} 〜 ${isWrap ? '<br>' : ''} ${testStartDateTimeTo}`;
    }

    const convertUploadedAt = (uploadedDate: any) => {
      return uploadedDate ? moment(uploadedDate).format('Y/M/D HH:mm') : "-";
    }

    const convertStatusText = (status: number) => {
      var rtn = "";
      if(status == 1){
        rtn = "試験開始前";
      }else if(status == 2){
        rtn = "試験中";
      }else{
        rtn = "試験終了";
      }
      return rtn;
    }

    const showSearchCondition = () => {
      context.root.$bvModal.show('modal-search-condition');
    }

    const downloadKaitouPdf = async (sheet: any) => {
      if(!window.confirm(`${sheet.name} ${context.root.$store.getters.getCurriculumNameById(sheet.curriculum_id)} ${sheet.subject_name} の解答用紙をダウンロードします。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      await http.get(`/api/student/kaitou_pdf?sheet_id=${sheet.id}`).then(response => {
        var mime_ctype = "application/pdf";
        var blob = toBlob(response.data.base64_pdf, mime_ctype);

        if (window.navigator.msSaveBlob) {
            // IEやEdgeの場合、Blob URL Schemeへと変換しなくともダウンロードできる
            window.navigator.msSaveOrOpenBlob(blob, "file.pdf"); 
        } else {
            // BlobをBlob URL Schemeへ変換してリンクタグへ埋め込む
            var downloadElm = document.createElement('a');
            downloadElm.href = window.URL.createObjectURL(blob);
            downloadElm.download = `${sheet.name} ${context.root.$store.getters.getCurriculumNameById(sheet.curriculum_id)} ${sheet.subject_name}.pdf`;
            // リンクをクリックする
            downloadElm.click();
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    const toBlob = (base64: string, mime_ctype: string) => {
        // 日本語の文字化けに対処するためBOMを作成する。
        var bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
 
        var bin = atob(base64.replace(/^.*,/, ''));
        var buffer = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) {
            buffer[i] = bin.charCodeAt(i);
        }
        // Blobを作成
        try {
            var blob = new Blob([bom, buffer.buffer], {
                type: mime_ctype,
            });
        } catch (e) {
            return false;
        }
        return blob;
    }

    const toUpload = async (sheet: any) => {

      if(sheet.sheet_uploaded_at != null && !window.confirm("解答用紙は既に提出されています。再提出しますか？")){
        return;
      }

      if(context.root.$store.getters.isAdmin){
        context.root.$router.push(`/teacher_site/student_sheet_upload/${sheet.id}`).catch(err => {});
      }else{
        context.root.$router.push(`/${state.school_id}/student_site/sheet_upload/${sheet.id}`).catch(err => {});
      }
      
    }

    const toResultRankDetail = (sheet_id: number, student_no: number) => {
      if(context.root.$store.getters.isAdmin){
        context.root.$router.push(`/teacher_site/result_rank_detail/${sheet_id}/${student_no}`).catch(err => {});
      }else{
        context.root.$router.push(`/${state.school_id}/student_site/result_rank_detail/${sheet_id}/${student_no}`).catch(err => {});
      }
    }

    const toMondaiPdfRender = (sheet_id: number) => {
      if(context.root.$store.getters.isAdmin){
        context.root.$router.push(`/teacher_site/mondai_pdf_render/${sheet_id}`).catch(err => {});
      }else{
        context.root.$router.push(`/${state.school_id}/student_site/mondai_pdf_render/${sheet_id}`).catch(err => {});
      }
    }

    const toDigitalPaperList = () => {
      if(context.root.$store.state.currentUser.role == Common.RoleEnum.Student){
        context.root.$router.push(`/${state.school_id}/student_site/digital_paper_list`).catch(err => {});
      }else{
        context.root.$router.push(`/teacher_site/digital_paper_list`).catch(err => {});
      }
    }

    const toFileList = () => {
      if(context.root.$store.state.currentUser.role == Common.RoleEnum.Student){
        context.root.$router.push(`/${state.school_id}/student_site/file_list`).catch(err => {});
      }else{
        context.root.$router.push(`/teacher_site/file_list`).catch(err => {});
      }
    }

    /******************************
     * 採点結果表示画面へ
     ******************************/

    const toResultImagePreview = async (sheet: any) => {
      if(context.root.$store.state.currentUser.role == Common.RoleEnum.Student){
        context.root.$router.push(`/${state.school_id}/student_site/result_image_preview/${sheet.id}`).catch(err => {});
      }else{
        context.root.$router.push(`/teacher_site/result_image_preview/${sheet.id}`).catch(err => {});
      }
    }

    /******************************
     * 答案PDFダウンロード
     ******************************/

    const downloadImage = async (sheet: any) => {
      context.root.$store.dispatch("showOverlay");
      
      await http.get(`/api/student/sheet_list/download_image/${sheet.id}/${context.root.$store.state.student_no_character}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.target = "_blank"
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = JSON.parse(new TextDecoder().decode(error.response.data)).errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    const modalShown = () => {
      const movieRoot = document.getElementById("movie-root");
      const img = document.createElement("img");
      const timestamp = new Date().getTime()
      img.src = require(`@/assets/gif/movie_student_manage_digital_paper.gif`) + "?" + timestamp
      img.style.width = "100%";
      movieRoot.appendChild(img);
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
      await search();
      state.isShow = true;
    })

    return {
      ...toRefs(state),
      searchClick,
      convertExecDate,
      convertTestStartDateTime,
      convertTestStartDateTimeMobile,
      convertUploadedAt,
      convertStatusText,
      showSearchCondition,
      downloadKaitouPdf,
      toBlob,
      toUpload,
      toResultRankDetail,
      toMondaiPdfRender,
      toDigitalPaperList,
      downloadImage,
      modalShown,
      clearCondition,
      toFileList,
      changePage,
      toResultImagePreview,
    }
  }
})
